module.exports = __webpack_public_path__ + "media/app/assets/classes/shaman-3b3f54fa446ee4973a5f3394c441afef.jpg";